import HttpClient from "@/common/boot/HttpClient"

const listarTecnicos = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  try {
    const response = await HttpClient.get('/ctrl-tecnicos', { params: payload });
    commit('LISTAR_DADOS', response.data.data);
    return response;
  } finally {
    commit('CARREGANDO', false);
  }
}

const listarTecnicosComPaginacao = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  try {
    const response = await HttpClient.get('/ctrl-tecnicos/listar/paginado', { params: payload });
    commit('LISTAR_DADOS_PAGINADOS', response.data.data);
    return response;
  } finally {
    commit('CARREGANDO', false);
  }
}

const excluirTecnico = async ({ commit }, payload) => {
    commit('CARREGANDO', true);

    try {
        await Promise.all(
            payload.map(item => excluir(item))
        );
    } finally {
        commit('CARREGANDO', false);
    }
}

const excluir = async(linha) => {
  const resp = await HttpClient.delete(`/ctrl-tecnicos/${linha.id}`).then(response => { return response; });
  return resp;
}

const salvarTecnico = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  return await HttpClient.post('/ctrl-tecnicos', payload).then(response => {
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const atualizarTecnico = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  return await HttpClient.put(`/ctrl-tecnicos/${payload.id}`, payload).then(response => {
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  })
}

const restaurarTecnico = async ({ commit }, payload) => {
    commit('CARREGANDO', true);

    return await HttpClient.post(`/ctrl-tecnicos/${payload}/restaurar/`).then(response => {
        return response;
    }).finally(() => {
        commit('CARREGANDO', false);
    });
}

const detalharTecnico = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  try {
    const response = await HttpClient.get(`/ctrl-tecnicos/${payload}`);
    return response.data.data;
  } finally {
    commit('CARREGANDO', false);
  }
}

export {
  listarTecnicos,
  excluirTecnico,
  salvarTecnico,
  atualizarTecnico,
  restaurarTecnico,
  listarTecnicosComPaginacao,
  detalharTecnico,
}
